import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import {
  ComingNomenclatureChangeStatus,
  ComingNomenclatureFare,
  ComingNomenclatureFareBalance,
  ComingNomenclatureFareRequest,
  ComingNomenclatureMain,
  ComingNomenclatureSalaryRequest,
  Status,
} from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getComingNomenclatureMainDetail: builder.query<ComingNomenclatureMain, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/${data.id}`,
      }),
      providesTags: ['comingNomenclature'],
    }),
    changeComingNomenclatureMain: builder.mutation<void, ComingNomenclatureMain>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createComingNomenclatureMain: builder.mutation<void, ComingNomenclatureMain>({
      query: (data) => ({
        url: '/v1/ComingNomenclature/',
        method: 'POST',
        body: data,
      }),
    }),
    deleteComingNomenclatureMain: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/${data.id}`,
        method: 'DELETE',
      }),
    }),
    getComingNomenclatureStatuses: builder.query<Status[], void>({
      query: () => ({
        url: '/v1/ComingNomenclature/statuses/',
      }),
    }),
    getComingNomenclatureFare: builder.query<ComingNomenclatureFareBalance, ComingNomenclatureFareRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/fare/${data.transportId}`,
        params: data,
      }),
    }),
    getDriverSalaryDetails: builder.query<ComingNomenclatureFare, ComingNomenclatureSalaryRequest>({
      query: (data) => ({
        url: `/v1/driverSalary/${data.driverId}/details`,
        params: data,
      }),
    }),
    getHistoryComingNomenclature: builder.query<any, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/${data.id}/history`,
        params: data,
      }),
    }),
    approveComingNomenclature: builder.mutation<void, string | null>({
      query: (params) => ({
        url: `/v1/comingNomenclature/Approved?&filter=${params}`,
        method: 'POST',
      }),
    }),
    changeStatusComingNomenclatureMain: builder.mutation<void, ComingNomenclatureChangeStatus>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/${data.id}/status`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['comingNomenclature'],
    }),
    getAvailableUnits: builder.query<Array<{ id: number; name: string }>, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/${data.id}/AvailableUnits`,
        params: data,
      }),
    }),
  }),
});

export const {
  useChangeComingNomenclatureMainMutation,
  useCreateComingNomenclatureMainMutation,
  useDeleteComingNomenclatureMainMutation,
  useGetComingNomenclatureMainDetailQuery,
  useLazyGetComingNomenclatureMainDetailQuery,
  useLazyGetComingNomenclatureStatusesQuery,
  useGetComingNomenclatureStatusesQuery,
  useLazyGetComingNomenclatureFareQuery,
  useLazyGetDriverSalaryDetailsQuery,
  useGetDriverSalaryDetailsQuery,
  useApproveComingNomenclatureMutation,
  useChangeStatusComingNomenclatureMainMutation,
  useGetHistoryComingNomenclatureQuery,
  useLazyGetHistoryComingNomenclatureQuery,
  useLazyGetAvailableUnitsQuery,
} = request;
